import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  style: {"display":"contents"},
  ref: "root"
}
const _hoisted_2 = { class: "ProductCategory-aside" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "ProductCategory-content" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { key: 4 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilterHolder = _resolveComponent("FilterHolder")!
  const _component_FilterSelection = _resolveComponent("FilterSelection")!
  const _component_ButtonOpenFilter = _resolveComponent("ButtonOpenFilter")!
  const _component_CategorySort = _resolveComponent("CategorySort")!
  const _component_ProductList = _resolveComponent("ProductList")!
  const _component_Pager = _resolveComponent("Pager")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_FilterHolder, { "is-loading": _ctx.isLoadingFilters }, null, 8, ["is-loading"]),
      (_ctx.catalogStore.layoutSections.banner)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            style: {"display":"contents"},
            innerHTML: _ctx.catalogStore.layoutSections.banner
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.catalogStore.layoutSections.categoryHeader)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            style: {"display":"contents"},
            innerHTML: _ctx.catalogStore.layoutSections.categoryHeader
          }, null, 8, _hoisted_5))
        : _createCommentVNode("", true),
      (_ctx.catalogStore.layoutSections.subCategories)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            style: {"display":"contents"},
            innerHTML: _ctx.catalogStore.layoutSections.subCategories
          }, null, 8, _hoisted_6))
        : _createCommentVNode("", true),
      (_ctx.catalogStore.layoutSections.topSeller)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            style: {"display":"contents"},
            innerHTML: _ctx.catalogStore.layoutSections.topSeller
          }, null, 8, _hoisted_7))
        : _createCommentVNode("", true),
      (_ctx.catalogStore.layoutSections.recommendedList)
        ? (_openBlock(), _createElementBlock("div", {
            key: 3,
            style: {"display":"contents"},
            innerHTML: _ctx.catalogStore.layoutSections.recommendedList
          }, null, 8, _hoisted_8))
        : _createCommentVNode("", true),
      (_ctx.isLoadingProducts)
        ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.loadingProductsLabel), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        style: {"display":"contents"},
        class: _normalizeClass({'u-hidden': _ctx.isLoadingProducts})
      }, [
        _createVNode(_component_FilterSelection),
        _createVNode(_component_ButtonOpenFilter, {
          text: _ctx.openFilterLabel,
          onClick: _ctx.openFilterModal
        }, null, 8, ["text", "onClick"]),
        _createVNode(_component_CategorySort),
        _createVNode(_component_ProductList),
        _createVNode(_component_Pager)
      ], 2)
    ])
  ], 512))
}